import React, { useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { isAudioEnabled, setAudioEnabled, startAmbient, stopAmbient } from "../lib/audio";

const AudioToggle = ({ ambient = false }) => {
  const [on, setOn] = useState(isAudioEnabled());

  const toggle = () => {
    const next = !on;
    setOn(next);
    setAudioEnabled(next);
    if (ambient) {
      if (next) startAmbient(); else stopAmbient();
    }
  };

  return (
    <button
      onClick={toggle}
      data-testid="audio-toggle"
      title={on ? "Mute" : "Unmute"}
      className="w-10 h-10 flex items-center justify-center bg-white border-2 border-[color:var(--deepest-brown)] hover:bg-[color:var(--yellow)] transition-colors"
      style={{ boxShadow: "3px 3px 0 0 var(--deepest-brown)" }}
    >
      {on ? <Volume2 size={18} color="var(--deepest-brown)" /> : <VolumeX size={18} color="var(--deepest-brown)" />}
    </button>
  );
};

export default AudioToggle;
